import { listen, qs, remove, toggle } from "@fluorescent/dom";
import PredictiveSearch from "@/lib/predictive-search";

const selectors = {
  clear: "[data-search-clear]",
  input: "[data-input]",
  results: "[data-search-results]",
  search: "[data-search-submit]",
};

export default function Search(container) {
  // Elements
  const input = qs(selectors.input, container);
  const resultsContainer = qs(selectors.results, container);
  const clearButton = qs(selectors.clear, container);
  const searchButton = qs(selectors.search, container);

  // Events
  const inputChange = listen(input, "input", handleInputChange);
  const clearClick = listen(clearButton, "click", reset);

  // This gets replaced with a focus trapping util on `open` however
  // this should prevent any errors if the quick search is destroyed
  // when it wasn't open
  let lockbox = () => {};

  const predictiveSearch = new PredictiveSearch(resultsContainer);

  function handleInputChange({ target: { value } }) {
    toggle(
      [resultsContainer, clearButton, searchButton],
      "visible",
      value !== ""
    );

    predictiveSearch.getSearchResults(value);
  }

  function reset(e) {
    e.preventDefault();
    input.value = "";
    remove([resultsContainer, clearButton, searchButton], "visible");
    resultsContainer.innerHTML = "";
    input.focus();
    lockbox();
  }

  function destroy() {
    inputChange();
    clearClick();
  }

  return { destroy };
}
